import { render, staticRenderFns } from "./lk-mobile-notify.vue?vue&type=template&id=5f95a9e8&"
import script from "./lk-mobile-notify.vue?vue&type=script&lang=js&"
export * from "./lk-mobile-notify.vue?vue&type=script&lang=js&"
import style0 from "./lk-mobile-notify.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/lk-mobile-notify.vue
// module id = 1696
// module chunks = 0